module.exports = "/assets/data/f28e899b09a1b75b53dbb669b161f5ce-SE28.data.json";